import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AccountProvider } from './contexts/AccountContext';
import { MarketingShell } from './components/MarketingShell';
import { AppShell } from './components/AppShell';
import { AdminShell } from './components/AdminShell';
import { RequireRole } from './components/RequireRole';
import { Landing } from './pages/marketing/Landing';
import { Pricing } from './pages/marketing/Pricing';
import { Brand } from './pages/marketing/Brand';
import { Login } from './pages/marketing/Login';
import { Signup } from './pages/marketing/Signup';
import { Checkout } from './pages/marketing/Checkout';
import { Dashboard } from './pages/app/Dashboard';
import { MonitorDetail } from './pages/app/MonitorDetail';
import { MonitorNew } from './pages/app/MonitorNew';
import { Notifications } from './pages/app/Notifications';
import { Alerts } from './pages/app/Alerts';
import { Billing } from './pages/app/Billing';
import { Settings } from './pages/app/Settings';
import { AdminOverview } from './pages/admin/AdminOverview';
import { AdminCustomers } from './pages/admin/AdminCustomers';
import { AdminCustomerDetail } from './pages/admin/AdminCustomerDetail';
import { AdminFleet } from './pages/admin/AdminFleet';
import { AdminRevenue } from './pages/admin/AdminRevenue';
import { AdminSystem } from './pages/admin/AdminSystem';
import { AdminStaff } from './pages/admin/AdminStaff';
export function App() {
  return <AuthProvider data-id="element-0" data-mp="33nq9g2keplaf">
      <AccountProvider data-id="element-1" data-mp="33n6w6z5pbl2q">
        <BrowserRouter data-id="element-2" data-mp="33oi1x4ipj2wh">
          <Routes data-id="element-3" data-mp="38l8idsyfc0if">
            <Route element={<MarketingShell data-id="element-5" data-mp="38l017ov9q91f" />} data-id="element-4" data-mp="38kqc03i1s5ws">
              <Route path="/" element={<Landing data-id="element-7" data-mp="3dkl0k0ecojeo" />} data-id="element-6" data-mp="38o4gpie6or7e" />
              <Route path="/pricing" element={<Pricing data-id="element-9" data-mp="3dirv2ofh4589" />} data-id="element-8" data-mp="3dlwa6guh8ldp" />
              <Route path="/brand" element={<Brand data-id="element-11" data-mp="nuhg0bzipzr4" />} data-id="element-10" data-mp="nvsvva68mxyl" />
            </Route>

            <Route path="/login" element={<Login data-id="element-13" data-mp="sudnwmbc6bby" />} data-id="element-12" data-mp="nxn902b9pls4" />
            <Route path="/signup" element={<Signup data-id="element-15" data-mp="sssrss9dikbz" />} data-id="element-14" data-mp="stko65asom3b" />
            <Route path="/checkout" element={<Checkout data-id="element-17" data-mp="35oxgs1yt6tn" />} data-id="element-16" data-mp="36hxla6f4y2t" />

            <Route path="/app" element={<RequireRole role="customer" data-id="element-19" data-mp="3udkr489qbgg7">
                  <AppShell data-id="element-20" data-mp="3uevqlvw5621i" />
                </RequireRole>} data-id="element-18" data-mp="34x31kk3tf4y">
              <Route index element={<Dashboard data-id="element-22" data-mp="d2bhjemgvtum" />} data-id="element-21" data-mp="d3wbp34vdary" />
              <Route path="monitors/new" element={<MonitorNew data-id="element-24" data-mp="8648hcyry28g" />} data-id="element-23" data-mp="851h73xjhxs0" />
              <Route path="monitors/:monitorId" element={<MonitorDetail data-id="element-26" data-mp="3gmfw5jhb3cc7" />} data-id="element-25" data-mp="83qivjmv5i8a" />
              <Route path="notifications" element={<Notifications data-id="element-28" data-mp="3bmjq7ep1tau0" />} data-id="element-27" data-mp="3glnym345f4ja" />
              <Route path="alerts" element={<Alerts data-id="element-30" data-mp="3bo4isyrsyjp8" />} data-id="element-29" data-mp="3bnct24kvzg6v" />
              <Route path="billing" element={<Billing data-id="element-32" data-mp="3qbg07hao0xx9" />} data-id="element-31" data-mp="3qb7m5m2t3mkh" />
              <Route path="settings" element={<Settings data-id="element-34" data-mp="3lkheu3atl9n5" />} data-id="element-33" data-mp="3qcr2tdsdjzms" />
            </Route>

            <Route path="/admin" element={<RequireRole role="admin" data-id="element-36" data-mp="2xud8ho68yvsg">
                  <AdminShell data-id="element-37" data-mp="2xt28lzfxa86m" />
                </RequireRole>} data-id="element-35" data-mp="3ljpigq9ef7vt">
              <Route index element={<AdminOverview data-id="element-39" data-mp="2stpklbdbev2g" />} data-id="element-38" data-mp="2svagb4bd8k1w" />
              <Route path="customers" element={<AdminCustomers data-id="element-41" data-mp="18czmmhs8vbly" />} data-id="element-40" data-mp="18d9ds8p0zot8" />
              <Route path="customers/:customerId" element={<AdminCustomerDetail data-id="element-43" data-mp="1d62hct8rcr3q" />} data-id="element-42" data-mp="18byae9zhsj2n" />
              <Route path="fleet" element={<AdminFleet data-id="element-45" data-mp="ygwkvd1b1ezj" />} data-id="element-44" data-mp="yg3n31kbpztj" />
              <Route path="revenue" element={<AdminRevenue data-id="element-47" data-mp="13eeuz6r26094" />} data-id="element-46" data-mp="ydik298ahdu7" />
              <Route path="system" element={<AdminSystem data-id="element-49" data-mp="13clobrgg3g14" />} data-id="element-48" data-mp="13fg9jl7a94vl" />
              <Route path="staff" element={<AdminStaff data-id="element-51" data-mp="1r5ame2rlqtfu" />} data-id="element-50" data-mp="1r4ip8nicwnng" />
            </Route>

            <Route path="*" element={<Navigate to="/" replace data-id="element-53" data-mp="1w3vn03arnf4t" />} data-id="element-52" data-mp="1r2g2ccci3amy" />
          </Routes>
        </BrowserRouter>
      </AccountProvider>
    </AuthProvider>;
}